import { CMS } from '~/scopes/cms/routes-names'
import { GIFT_CARDS } from '~/scopes/gift-cards/routes.constants'
import { HELP_CENTER } from '~/scopes/help-center/route-names'
import { LEGAL_PAGE_NAME } from '~/scopes/legal/constants'
import { MODELS_COMPARISON } from '~/scopes/models-comparison/routes-names'
import { ROUTES as REVIEWS_ROUTES } from '~/scopes/reviews/route-names'

import type {
  FooterConsentLink,
  FooterExternalLink,
  FooterRouteLink,
} from './types'

export const aboutUs: FooterRouteLink = {
  translationKey: 'aboutUs',
  route: { name: CMS.ABOUT_US },
}

export const accessibility: FooterRouteLink = {
  translationKey: 'accessibilityStatement',
  route: { name: CMS.STATEMENT },
}

export const modelsComparison: FooterRouteLink = {
  translationKey: 'modelsHomeComparison',
  route: { name: MODELS_COMPARISON.HOME },
  prefetch: false,
}

export const allCustomerReviews: FooterRouteLink = {
  translationKey: 'allCustomerReviews',
  route: { name: REVIEWS_ROUTES.PAGES.ALL },
}

export const giftCards: FooterRouteLink = {
  translationKey: 'giftCards',
  route: { name: GIFT_CARDS.INDEX },
  featureFlag: { name: 'experiment.giftCards', value: 'withGiftCards' },
}

export const giftFinder: FooterRouteLink = {
  translationKey: 'giftFinder',
  route: { name: CMS.GIFT_FINDER_HOME, params: { pageName: 'home' } },
}

export const giftFinderExternal: FooterExternalLink = {
  translationKey: 'giftFinder',
  href: 'https://www.backmarket.com/en-us/gift',
}

export const buyBack: FooterRouteLink = {
  translationKey: 'buyback',
  route: { name: CMS.BUYBACK, params: { pageName: 'home' } },
}

export const buyingGuides: FooterRouteLink = {
  translationKey: 'buyingGuides',
  route: { name: CMS.ARTICLE_ROOT_HUB },
}

export const studentGoodDeals: FooterRouteLink = {
  translationKey: 'studentGoodDeals',
  route: { name: CMS.STUDENT_DISCOUNT },
}

export const militaryProgram: FooterRouteLink = {
  translationKey: 'militaryProgram',
  route: { name: CMS.MILITARY_DISCOUNT },
}

export const backmarketWarranty: FooterRouteLink = {
  translationKey: 'backmarketWarranty',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.WARRANTY },
  },
}

export const referFriend: FooterRouteLink = {
  translationKey: 'referFriend',
  route: { name: CMS.EVENT, params: { pageName: 'refer-friend' } },
}

export const boMerchant: FooterExternalLink = {
  translationKey: 'boMerchant',
  href: '/bo-seller',
}

export const help: FooterRouteLink = {
  translationKey: 'help',
  route: { name: HELP_CENTER.HOME },
}

export const insurances: FooterRouteLink = {
  translationKey: 'insurances',
  route: { name: CMS.EVENT, params: { pageName: 'backup' } },
}

export const termsUse: FooterRouteLink = {
  translationKey: 'terms',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.TERMS_USE },
  },
}

export const termsService: FooterRouteLink = {
  translationKey: 'terms',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.TERMS_SERVICE },
  },
}

export const termsSale: FooterRouteLink = {
  translationKey: 'termsSale',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.TERMS_SALE },
  },
}

export const termsBuyback: FooterRouteLink = {
  translationKey: 'termsBuyback',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.BUYBACK },
  },
}

export const dataProtection: FooterRouteLink = {
  translationKey: 'dataProtection',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.DATA_PROTECTION },
  },
}

export const cookiePolicy: FooterConsentLink = {
  translationKey: 'cookies',
  action: 'consent',
}

export const ccpa: FooterConsentLink = {
  translationKey: 'doNotSell',
  action: 'consent',
}

export const infosConsumer: FooterRouteLink = {
  translationKey: 'infosConsumer',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.OTHER },
  },
}

export const legal: FooterRouteLink = {
  translationKey: 'legal',
  route: {
    name: CMS.LEGAL_PAGE,
    params: { pageName: LEGAL_PAGE_NAME.LEGAL_MENTIONS },
  },
}

export const blackFriday: FooterRouteLink = {
  translationKey: 'blackFriday',
  route: { name: CMS.EVENT, params: { pageName: 'black-friday' } },
}

export const hireExternal: FooterExternalLink = {
  translationKey: 'hire',
  href: 'https://www.backmarket.com/en-us/careers/home',
}

export const hireInternal: FooterRouteLink = {
  translationKey: 'hire',
  route: { name: CMS.CAREERS_HOME, params: { pageName: 'home' } },
}

export const medium: FooterExternalLink = {
  translationKey: 'medium',
  href: 'https://medium.com/@BackMarket',
}

export const welcomeToTheJungle: FooterExternalLink = {
  translationKey: 'welcomeToTheJungle',
  href: 'https://www.welcometothejungle.co/fr/companies/back-market',
}
